import React, {FunctionComponent, useContext} from "react";
import "./InvoiceActionRow.scss";
import {Invoice} from "../../models/invoice.model";
import {InvoiceContext} from "../../context/InvoiceContext";
import {Button} from "../ui-components/Button/Button";
import {SignatureSignIn} from "../SignatureSignIn/SignatureSignIn";

interface InvoiceActionRowProps {
    onClickPayNow: () => void;
}

export const InvoiceActionRow: FunctionComponent<InvoiceActionRowProps> = ({onClickPayNow}) => {
    const invoice: Invoice = useContext(InvoiceContext);

    return (
        <div className="general-buttons">
            {invoice.is_payment_available ?
                <Button onClick={onClickPayNow} className="payment-button">
                    <i className="fa-regular fa-cart-shopping"></i>
                    Pay Now
                </Button> : null}
            {invoice.is_signature_available ? <SignatureSignIn/> : null}
        </div>
    );
};
